/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { dataActions } from "../../../shared/store/dataSlice";
import { CloseBtn, SearchIcon } from "../svg/AllSvg";

const Search = () => {
    const searchOpen: boolean = useSelector((state: any) => state.data.searchOpen);
    const [search, setSearch] = useState<string>("");
    const [focus, setFocus] = useState<boolean>(false);
    const headerMenuData: any[] = useSelector((state: any) => state.data.headerMenuData);
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation('common');

    document.onkeydown = function (evt: any) {
        if (evt.keyCode === 27) {
            dispatch(dataActions.setSearchOpen(false))
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            if (document.body.offsetHeight > 0) {
                dispatch(dataActions.setSearchOpen(false))
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [window.scrollY])

    useEffect(() => {
        !!params?.search && setSearch(params?.search);
    }, [params?.search])

    const handleLink = (e: any, url: any) => {
        e.preventDefault();
        dispatch(dataActions.setWebOpen(true));
        dispatch(dataActions.setLink(url));
    }

    return (
        <div className={`${!searchOpen ? "translate-x-full" : ""} w-full fixed left-0 right-0 top-[95px] bg-[#F2F4F5] dark:bg-[#20222b] z-30 transition duration-400 px-[15px] py-[40px] sm:p-[40px]`}>
            <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="absolute top-[30px] right-[30px] rounded-full min-w-[28px] h-[28px] flex items-center justify-center focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] z-[2] " onClick={() => dispatch(dataActions.setSearchOpen(false))}>
                <CloseBtn className='' />
            </button>

            <div className={`container !max-w-[900px] flex flex-col gap-[20px] ${searchOpen ? 'fade-in-up' : ''}`}>
                <form onSubmit={(e: any) => { e.preventDefault(); if (!!search) { navigate(`/search/${search}`); dispatch(dataActions.setSearchOpen(false)); } }} className={`border-b dark:border-[#454545] border-[#AAA] pb-[12px] xlx:pb-[15px] flex items-center gap-[10px] xlx:gap-[12px] w-full ${focus ? "border-[#343a40] shadow-[0_4px_6px_-6px_#343a405e] dark:border-[#ffffff80] dark:shadow-[0_4px_6px_-6px_#ffffff5e]" : "hover:border-[#343a40] hover:dark:border-[#ffffff80]"}`}>
                    <SearchIcon className="min-w-[22px] w-[22px] h-[22px] fill-primaryText dark:fill-white" />

                    <input type="text" className="text-primaryText dark:text-white placeholder:dark:text-white font-medium placeholder:text-primaryText placeholder:text-opacity-[0.5] dark:placeholder:text-opacity-[0.5] text-2xl placeholder:leading-tight w-full bg-transparent" placeholder={t("search.placeholder")} autoComplete="off" value={search} onChange={(e: any) => setSearch(e.target.value)} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} autoFocus />
                </form>

                <div className="w-full flex flex-col gap-[15px]">
                    <h5 className="text-primaryText dark:text-white font-medium uppercase">{t("search.popular_page")}</h5>
                    <div className="grid grid-cols-2 xsm:grid-cols-3 gap-[15px] w-full">
                        {Array?.isArray(headerMenuData) && headerMenuData?.slice(0, 8)?.map((item: any, index: number) => (
                            <Link key={index} to={item?.url?.replace(`/en/`, "")} onClick={(e: any) => item?.url_type === "external" && handleLink(e, item?.url?.replace(`/en/`, ""))} className="text-base font-semibold focus:underline hover:underline text-[#4D4C4C] dark:text-white">{item?.title}</Link>
                        ))}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Search;